var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { configureStore as configureReduxStore, Tuple, } from '@reduxjs/toolkit';
import { filtersReducer } from './filters/filters.slice';
import { generalReducer } from './general/general.slice';
export var configureStore = function (_a) {
    var _b = _a.middlewares, middlewares = _b === void 0 ? [] : _b, enhancer = _a.enhancer, initialState = _a.initialState;
    var store = configureReduxStore({
        reducer: {
            // RTK 2: explicit cast to include PreloadedState | undefined in 3rd type param
            general: generalReducer,
            filters: filtersReducer,
        },
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware().concat(new (Tuple.bind.apply(Tuple, __spreadArray([void 0], middlewares, false)))());
        },
        enhancers: function (getDefaultEnhancers) {
            var defaults = getDefaultEnhancers();
            return enhancer ? defaults.concat(new Tuple(enhancer)) : defaults;
        },
        preloadedState: initialState,
    });
    return store;
};
